import { TripType, TripTypeIds } from '@pages/trips-page/constants';

export default class TripTypeUtils {
  static getTripTypeId(type: TripType): number | undefined {
    return Number(
      Object.keys(TripTypeIds).find(key => TripTypeIds[Number(key)] === type)
    );
  }
}
